// THE single authoritative module-identity configuration for the ecosystem.
// The TFS App Hub Welcome Screen is the branding source: `icon` is the exact
// approved asset it renders (shared APP_ICONS mapping) and `color` is the approved
// module identity / selected-navigation accent. Reuse this everywhere a module
// shows its OWN application identity (sidebar brand, mobile top-bar icon, mobile
// nav grid selected tile) so a future icon or colour change propagates automatically.
//
// Functional sub-section icons (Work Orders, Customers, Reports, Inspections, …)
// are intentionally NOT part of this config and must not be synchronised here.
import { APP_ICONS } from '@/lib/appIcons';

export const MODULE_IDENTITY = {
  tfs_admin:        { key: 'tfs_admin',        label: 'Administration', route: '/tfs-admin',        icon: APP_ICONS.tfs_admin,        color: '#64748B' }, // charcoal / silver
  tfs_ops:          { key: 'tfs_ops',          label: 'Operations',     route: '/tfs-ops',          icon: APP_ICONS.tfs_ops,          color: '#5FA718' }, // green
  rout_admin:       { key: 'rout_admin',       label: 'ROUT',           route: '/rout-admin',       icon: APP_ICONS.rout_admin,       color: '#C8961E' }, // gold
  contract_budgets: { key: 'contract_budgets', label: 'Tally',          route: '/contract-budgets', icon: APP_ICONS.contract_budgets, color: '#7C3AED' }, // purple
  payroll:          { key: 'payroll',          label: 'Total Pay',      route: '/payroll',          icon: APP_ICONS.payroll,          color: '#F97316' }, // orange
  team:             { key: 'team',             label: 'TEAM',           route: '/team-hub',         icon: APP_ICONS.team,             color: '#1C4FC9' }, // blue
};

export const moduleIcon = (key) => MODULE_IDENTITY[key]?.icon || null;
export const moduleColor = (key) => MODULE_IDENTITY[key]?.color || null;
